export const geti18nKey = (usersCount: number): string => {
  switch (usersCount) {
    case 1:
      return 'Journey:ContentConsumptionBanner';
    case 2:
      return 'Journey:ContentConsumptionBannerFor2Users';
    default:
      return 'Journey:ContentConsumptionBannerPlural';
  }
};
